import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalInstance";

// ResizeObserver 에러 무시 (React Flow NodeResizer 사용 시 발생하는 무해한 에러)
// 이 에러는 리사이즈 중 DOM 변경과 React 렌더링 사이클 간의 타이밍 이슈로 발생하며, 
// 실제 기능에는 영향을 주지 않습니다.

// 방법 1: window.onerror 핸들러
const resizeObserverErr = window.onerror;
window.onerror = (message, ...args) => {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true;
  }
  if (resizeObserverErr) {
    return resizeObserverErr(message, ...args);
  }
  return false;
};

// 방법 2: error 이벤트 리스너 (캡처 단계에서 처리)
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
}, true); // 캡처 단계에서 처리

// 방법 3: unhandledrejection 이벤트 리스너
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver loop')) {
    e.preventDefault();
  }
});

// 방법 4: ResizeObserver 자체를 래핑하여 에러 무시
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // requestAnimationFrame으로 감싸서 에러 방지
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

// Favicon 복원 함수 (MSAL 리다이렉트 후 Microsoft favicon이 남는 문제 해결)
const FAVICON_SVG = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><rect width='100' height='100' rx='20' fill='%23ccc5b9'/><text x='50' y='68' font-size='50' text-anchor='middle' fill='%233e3832' font-family='system-ui'>I</text></svg>";

const restoreFavicon = () => {
  const link = document.querySelector("link[rel~='icon']");
  if (link) {
    link.href = FAVICON_SVG;
  }
};

// 리디렉트 후 토큰 처리 (loginRedirect 사용 시 필수)
// 이 함수가 호출되지 않으면 로그인이 무한 반복됨
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        
        msalInstance.setActiveAccount(response.account);
      }
      // 리다이렉트 후 favicon 복원
      restoreFavicon();
    })
    .catch((error) => {
      console.error('❌ 리디렉트 처리 실패:', error);
    })
    .finally(() => {
      // 리디렉트 처리 완료 후 앱 렌더링
      const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(
        <React.StrictMode>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </React.StrictMode>
      );
    });
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
